/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react';
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
import Skeletonui from '../Components/Skeletonui'
import { useState, useEffect } from "react";
import Iframe from 'react-iframe'
   import {
     Card,
     CardHeader,
     CardBody,
     CardFooter,
     Typography,
    } from "@material-tailwind/react";
     
import { Link } from 'react-router-dom';

import { Avatar } from "@material-tailwind/react";
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
 import Paper from '@mui/material/Paper';
 import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';


import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem, 
} from "@material-tailwind/react";
 
 import {
  Drawer,
  Button,
   IconButton,
  List,
  ListItem,
  ListItemPrefix,
  ListItemSuffix,
  Chip,
 } from "@material-tailwind/react"; 
import { useNavigate} from "react-router-dom";
import Navbarsection from '../views/Home/Navbarsection';
 

const Sitekitthemes = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }, []);
    const navigate = useNavigate();
    return (
        <> 
           <Navbarsection/>

     
{loading ? <Skeletonui />  :  

<>

<div className="">
 
{loading ? <Skeletonui />  : 
 <Iframe url="https://sitekitpro.com/SITEKITPROREACT/catlog/all-sitekit-themes/index.html"
   width="100%"
   height="900px" 
   display="block"
   position="relative"/>   }

  {/*  Dextop Only  */}
  
 </div>
</>
 
}

  {/*  Dextop Only  */}
   
        </>
    );
}

export default Sitekitthemes;
